import { Image, Stack, Text } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import React, { useCallback } from 'react';
import arrowIcon from '../../../assets/icons/svg/arrow.svg';
import { useLotsCommerciaux, useLotsCommerciauxManager } from '../../../contexts/lotCommercialContext';
import Vignette from '../../Vignette';

const UserMenuDropdown = () => {

    const { lotCommercialActif, lotsCommerciaux, idOperationActive, idLotCommercialActif } = useLotsCommerciaux();
    const { updateLotCommercialActif } = useLotsCommerciauxManager();

    const [isExpanded, { toggle }] = useBoolean(false);

    const styles = {
        arrow: {
            root: {
                cursor: "pointer",
                transform: isExpanded ? "rotate(180deg)" : "unset",
            },
        },
        activeItem: {
            root: {
                backgroundColor: "rgba(236, 236, 236, 0.7)",
                minHeight: 62,
                padding: "0 24px",
            },
        },
        activeItemText: {
            root: {
                color: "#8A8A8A",
                fontSize: 16,
                fontWeight: 700,
                lineHeight: "15px",
            },
        },
        options: {
            root: {
                display: isExpanded ? "flex" : "none",
            },
        },
        option: {
            root: {
                minHeight: 62,
                paddingLeft: 24,
                paddingRight: 24,
                selectors: {
                    "&:hover": {
                        borderLeft: "2px solid red",
                        cursor: "pointer",
                        paddingLeft: 22
                    },
                    "&:last-child > span": { borderBottom: "none" }
                }
            },
        },
        optionText: {
            root: {
                alignItems: "center",
                borderBottom: "1px solid #DADADA",
                color: "#8A8A8A",
                display: "flex",
                flexGrow: 1,
                fontSize: 16,
                fontWeight: 400,
                height: "100%",
                lineHeight: "15px",
                paddingLeft: 48,
                paddingRight: 48,
            },
        },
        outer: { root: { borderBottom: "1px solid #DADADA" } }
    };

    const onClickOption = useCallback((idOperation, idLotCommercial) => () => {
        updateLotCommercialActif(idOperation, idLotCommercial);
        toggle();
    }, [toggle, updateLotCommercialActif]);

    if (lotsCommerciaux.length === 0) return null;
    else return <Stack styles={styles.outer}>
        {!!lotCommercialActif &&
            <Stack horizontal horizontalAlign="space-between" verticalAlign="center" styles={styles.activeItem}>
                <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 11 }}>
                    <Vignette src={lotCommercialActif.src} />
                    <Text styles={styles.activeItemText}>{[lotCommercialActif.numero, lotCommercialActif.nomCommercial].join(" - ")}</Text>
                </Stack>
                {lotsCommerciaux.length > 1 && <Image src={arrowIcon} onClick={toggle} styles={styles.arrow} />}
            </Stack>
        }
        <Stack styles={styles.options}>
            {lotsCommerciaux
                .filter(lot => lot.idOperation !== idOperationActive || lot.idLotCommercial !== idLotCommercialActif)
                .map(((lot, index) => {
                    const { idLotCommercial, idOperation, numero, nomCommercial } = lot;
                    return <Stack key={index} verticalAlign="center" styles={styles.option} onClick={onClickOption(idOperation, idLotCommercial)}>
                        <Text styles={styles.optionText}>{[numero, nomCommercial].join(" - ")}</Text>
                    </Stack>;
                }))
            }
        </Stack>
    </Stack >;

};

export default UserMenuDropdown;